import { useTranslation } from 'react-i18next';
import { GrDocumentPdf } from 'react-icons/gr';
import {
  Button,
  Tooltip,
  TooltipTriggerWrapper,
} from '@breezeai-frontend/cargo-ui';

import { usePlatform } from '../../../context/PlatformContext';

export function PdfTooltip() {
  const { t } = useTranslation();
  const { platform } = usePlatform();

  return (
    <TooltipTriggerWrapper delay={0}>
      <Button variant="icon" customStyles="text-icons-default">
        <GrDocumentPdf className="text-icons-primary" />
      </Button>
      <Tooltip placement="top">
        {t('routeDetails.PdfOverrideFieldTooltip', {
          ns: 'common',
          context: platform,
        })}
      </Tooltip>
    </TooltipTriggerWrapper>
  );
}
